import { render, staticRenderFns } from "./FormFornecedor.vue?vue&type=template&id=a478fec8&"
import script from "./FormFornecedor.vue?vue&type=script&lang=js&"
export * from "./FormFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./FormFornecedor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports